// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Authorization_authPage__3vjJA {
  min-height: 100vh;
  background: linear-gradient(black, #212529);
  display: flex;
  align-items: center;
  justify-content: center;
}

.Authorization_authbutton__9aw8T {
  background-color: rgba(255, 235, 59, 0.24);
  border-color: rgba(255, 235, 59, 0.24);
  color: #444141;
}`, "",{"version":3,"sources":["webpack://./src/components/Authorization/Authorization.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB","sourcesContent":[".authPage {\n  min-height: 100vh;\n  background: linear-gradient(black, #212529);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.authbutton {\n  background-color: rgba(255, 235, 59, 0.24);\n  border-color: rgba(255, 235, 59, 0.24);\n  color: #444141;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"authPage": `Authorization_authPage__3vjJA`,
	"authbutton": `Authorization_authbutton__9aw8T`
};
export default ___CSS_LOADER_EXPORT___;
